/* Microsoft Clarity heatmap loader — Feb-2026.
 *
 * Loads the Clarity JS tag when REACT_APP_MICROSOFT_CLARITY_PROJECT_ID
 * is set in /app/frontend/.env (or the deployment env). No-op when the
 * ID is missing so preview / dev builds don't ping Clarity.
 *
 * Mounted once at the top of AppRouter so every route
 * (landing, bookstore, sample reader, workspace, admin) is tracked.
 */
import { useEffect } from 'react';

const PROJECT_ID = (process.env.REACT_APP_MICROSOFT_CLARITY_PROJECT_ID || '').trim();

export default function ClarityLoader() {
  useEffect(() => {
    if (!PROJECT_ID) return;
    if (typeof window === 'undefined') return;
    if (window.clarity) return;                            // already loaded
    if (document.getElementById('ms-clarity-tag')) return; // race guard
    // Official Clarity snippet (function form so we don't clobber globals).
    /* eslint-disable no-var, prefer-const, no-sequences */
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.id = 'ms-clarity-tag';
      t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', PROJECT_ID);
    /* eslint-enable */
  }, []);
  return null;
}
